"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    iconToggleButtonEmphases: ()=>iconToggleButtonEmphases,
    iconToggleButtonEmphasisVariants: ()=>iconToggleButtonEmphasisVariants,
    iconToggleButtonVariants: ()=>iconToggleButtonVariants
});
const tv_cjs_namespaceObject = require("../../variants/tv.cjs");
const icongraphy_variants_cjs_namespaceObject = require("../../variants/interactions/icongraphy.variants.cjs");
const iconToggleButtonEmphasisVariants = {
    regular: {},
    bold: {}
};
const iconToggleButtonEmphases = Object.keys(iconToggleButtonEmphasisVariants);
const iconToggleButtonVariants = (0, tv_cjs_namespaceObject.tv)({
    slots: {
        iconBorderSlot: 'fill-transparent transition-colors',
        iconFillSlot: 'fill-transparent stroke-0 transition-colors'
    },
    variants: {
        size: icongraphy_variants_cjs_namespaceObject.sizeVariants,
        isToggledOn: {
            true: {},
            false: {}
        },
        emphasis: {
            regular: {
                iconFillSlot: ''
            },
            bold: {
                iconBorderSlot: 'drop-shadow-md'
            }
        },
        onHover: {
            true: {
                iconBorderSlot: 'cursor-pointer',
                iconFillSlot: 'cursor-pointer'
            },
            false: {}
        },
        disabled: {
            true: {
                iconBorderSlot: '',
                iconFillSlot: ''
            },
            false: {
                iconBorderSlot: '',
                iconFillSlot: ''
            }
        },
        palette: {
            primary: {
                iconBorderSlot: 'fill-actionPrimary-8',
                iconFillSlot: ''
            },
            favorite: {
                iconBorderSlot: 'fill-favorite-8',
                iconFillSlot: ''
            }
        }
    },
    compoundVariants: [
        {
            emphasis: 'regular',
            palette: 'primary',
            onHover: false,
            isToggledOn: false,
            class: {
                iconBorderSlot: '',
                iconFillSlot: ''
            }
        },
        {
            emphasis: 'regular',
            palette: 'primary',
            onHover: true,
            isToggledOn: false,
            class: {
                iconBorderSlot: 'fill-actionPrimary-9',
                iconFillSlot: ''
            }
        },
        {
            emphasis: 'regular',
            palette: 'primary',
            onHover: false,
            isToggledOn: true,
            class: {
                iconBorderSlot: 'fill-actionPrimary-8',
                iconFillSlot: 'fill-actionPrimary-8'
            }
        },
        {
            emphasis: 'regular',
            palette: 'primary',
            onHover: true,
            isToggledOn: true,
            class: {
                iconBorderSlot: 'fill-actionPrimary-9',
                iconFillSlot: 'fill-actionPrimary-9'
            }
        },
        {
            emphasis: 'bold',
            palette: 'primary',
            onHover: false,
            isToggledOn: false,
            class: {
                iconBorderSlot: 'fill-actionPrimary-1',
                iconFillSlot: ''
            }
        },
        {
            emphasis: 'bold',
            palette: 'primary',
            onHover: true,
            isToggledOn: false,
            class: {
                iconBorderSlot: 'fill-actionPrimary-1',
                iconFillSlot: ''
            }
        },
        {
            emphasis: 'bold',
            palette: 'primary',
            onHover: false,
            isToggledOn: true,
            class: {
                iconBorderSlot: 'fill-actionPrimary-1',
                iconFillSlot: 'fill-actionPrimary-8'
            }
        },
        {
            emphasis: 'bold',
            palette: 'primary',
            onHover: true,
            isToggledOn: true,
            class: {
                iconBorderSlot: 'fill-actionPrimary-1',
                iconFillSlot: 'fill-actionPrimary-9'
            }
        },
        {
            emphasis: 'regular',
            palette: 'favorite',
            onHover: false,
            isToggledOn: false,
            class: {
                iconBorderSlot: '',
                iconFillSlot: ''
            }
        },
        {
            emphasis: 'regular',
            palette: 'favorite',
            onHover: true,
            isToggledOn: false,
            class: {
                iconBorderSlot: 'fill-favorite-9',
                iconFillSlot: ''
            }
        },
        {
            emphasis: 'regular',
            palette: 'favorite',
            onHover: false,
            isToggledOn: true,
            class: {
                iconBorderSlot: 'fill-favorite-8',
                iconFillSlot: 'fill-favorite-8'
            }
        },
        {
            emphasis: 'regular',
            palette: 'favorite',
            onHover: true,
            isToggledOn: true,
            class: {
                iconBorderSlot: 'fill-favorite-9',
                iconFillSlot: 'fill-favorite-9'
            }
        },
        {
            emphasis: 'bold',
            palette: 'favorite',
            onHover: false,
            isToggledOn: false,
            class: {
                iconBorderSlot: 'fill-actionPrimary-1',
                iconFillSlot: ''
            }
        },
        {
            emphasis: 'bold',
            palette: 'favorite',
            onHover: true,
            isToggledOn: false,
            class: {
                iconBorderSlot: 'fill-actionPrimary-1',
                iconFillSlot: 'fill-actionPrimary-13/40'
            }
        },
        {
            emphasis: 'bold',
            palette: 'favorite',
            onHover: false,
            isToggledOn: true,
            class: {
                iconBorderSlot: 'fill-actionPrimary-1',
                iconFillSlot: 'fill-favorite-8'
            }
        },
        {
            emphasis: 'bold',
            palette: 'favorite',
            onHover: true,
            isToggledOn: true,
            class: {
                iconBorderSlot: 'fill-actionPrimary-1',
                iconFillSlot: 'fill-favorite-9'
            }
        }
    ],
    defaultVariants: {
        size: '32',
        emphasis: 'regular',
        isToggledOn: false,
        disabled: false,
        palette: 'primary'
    }
});
exports.iconToggleButtonEmphases = __webpack_exports__.iconToggleButtonEmphases;
exports.iconToggleButtonEmphasisVariants = __webpack_exports__.iconToggleButtonEmphasisVariants;
exports.iconToggleButtonVariants = __webpack_exports__.iconToggleButtonVariants;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "iconToggleButtonEmphases",
    "iconToggleButtonEmphasisVariants",
    "iconToggleButtonVariants"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
